import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgcGlobalNav } from '../../header/global-nav.component';

declare let delta: any;

@Component({
  selector: 'ngc-skip-navigation',
  templateUrl: 'skip-navigation.component.html'
})
export class SkipNavigationComponent {
  @Input() globalNav: NgcGlobalNav;
  @Input() textToDisplay = 'SKIP TO BOOK';
  @Output() navigatedToFirstElEvent = new EventEmitter();

  constructor() {}

  navigateToFirstElement() {
    if (this.globalNav) {
      if (this.globalNav.ngcGlobalElementRef) {
        const focusableElement =
          this.globalNav.ngcGlobalElementRef.nativeElement.querySelector(
            '.focusable-element'
          );
        if (focusableElement) {
          focusableElement.focus();
        }
      }
    }
    this.navigatedToFirstElEvent.emit();
  }
}
